/* PRODUCTS */
export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL"

export const ADD_PRODUCT = "ADD_PRODUCT"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL"

export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL"

export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL"

/* PURCHASES */
export const GET_PURCHASES = "GET_PURCHASES"
export const GET_PURCHASES_SUCCESS = "GET_PURCHASES_SUCCESS"
export const GET_PURCHASES_FAIL = "GET_PURCHASES_FAIL"

export const ADD_PURCHASE = "ADD_PURCHASE"
export const ADD_PURCHASE_SUCCESS = "ADD_PURCHASE_SUCCESS"
export const ADD_PURCHASE_FAIL = "ADD_PURCHASE_FAIL"

export const UPDATE_PURCHASE = "UPDATE_PURCHASE"
export const UPDATE_PURCHASE_SUCCESS = "UPDATE_PURCHASE_SUCCESS"
export const UPDATE_PURCHASE_FAIL = "UPDATE_PURCHASE_FAIL"

export const DELETE_PURCHASE = "DELETE_PURCHASE"
export const DELETE_PURCHASE_SUCCESS = "DELETE_PURCHASE_SUCCESS"
export const DELETE_PURCHASE_FAIL = "DELETE_PURCHASE_FAIL"

export const GET_ARRIVED_PURCHASES = 'GET_ARRIVED_PURCHASES';
export const GET_ARRIVED_PURCHASES_SUCCESS = 'GET_ARRIVED_PURCHASES_SUCCESS';
export const GET_ARRIVED_PURCHASES_FAIL = 'GET_ARRIVED_PURCHASES_FAIL';

export const GET_ARRIVED_PRODUCTS = 'GET_ARRIVED_PRODUCTS';
export const GET_ARRIVED_PRODUCTS_SUCCESS = 'GET_ARRIVED_PRODUCTS_SUCCESS';
export const GET_ARRIVED_PRODUCTS_FAIL = 'GET_ARRIVED_PRODUCTS_FAIL';

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"